import { fromEvent } from 'rxjs';
import { first } from 'rxjs/operators';
import * as loadImage from 'blueimp-load-image';

/**
 * Convert a data url to a file
 */
export function dataUrlToFile(dataUrl: string, filename: string): File {
    if(!dataUrl) console.error("No data url, could not convert it to file");

    let arr: string[] = dataUrl.split(',');
    if(!arr) return null;

    let mime = arr[0].match(/:(.*?);/)[1];
    let blobStr = atob(arr[1]);

    let u8arr = new Uint8Array(blobStr.length);
    for(let i = blobStr.length; i >= 0; i--) {
        u8arr[i] = blobStr.charCodeAt(i);
    }
    return new File([u8arr], filename, { type: mime });
}

/**
 * Convert a file to a data url
 */
export async function fileToDataUrl(image: File) : Promise<string> {
    if(!image) return '';

    // Create a file reader to read the image stream
    const reader = new FileReader();
    // Start reading url stream
    reader.readAsDataURL(image);
    // If stream is already loaded at this point return result
    if(reader.result) return reader.result as string;

    // Await image stream has loaded
    await fromEvent(reader, 'load').pipe(first()).toPromise();
    // Return image as data url
    return reader.result as string;
}

/**
 * Apply rotation of an image with exif data, remove the exif and return as base64 url data image string
 */
export async function urlToBase64WithoutExif(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
        // Load image from url
        loadImage(url, (canvas) => {
            if (canvas.type == "error") {
                console.log("Could no load image with loadImage canvas", canvas?.type);
                return reject("Error loading image");
            }
            // Convert canvas to Base64
            resolve(canvas.toDataURL());
        },
            // Options: Fix orientation and return a canvas
            { orientation: true, canvas: true }
        );
    });
}

/**
 * Convert a http image url to a data url (async download image and convert to base64 data url)
 */
export function imageUrlToDataUrl(url): Promise<string> {
    return new Promise((resolve, fail) => {
        let req = new XMLHttpRequest();
        req.onload = () => {
            let reader = new FileReader();
            reader.onloadend = () => {
                resolve(<string>reader.result);
            };
            reader.readAsDataURL(req.response);
        };
        // Send request for image blob
        req.open('GET', url);
        req.responseType = 'blob';
        req.send();
    });
}
